<template>
  <v-dialog
    v-model="menu"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Are you sure?</span>
      </v-card-title>
      <v-card-text class="font-weight-bold">
        Please make sure all the emails input are correct. Proceed to email?
      </v-card-text>
      <v-card-text class="py-0 text-center">
        <span class="text-uppercase text-danger">Once the email sent, it could not be retracted.</span>
      </v-card-text>
      <v-card-actions class="py-4">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      toggleDialog () {
        this.menu = true
      },
      submitForm () {
        this.$emit('email')
        this.menu = false
      },
    },
  }
</script>
